import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../api";
import { Bounce, toast } from "react-toastify";
import "./ricerche.css";
import CustomSelect from "../CustomSelect";

const EditRicerche = () => {
  const { id } = useParams();
  const [ricerca, setRicerca] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [sedi, setSedi] = useState([]);
  const [mansioni, setMansioni] = useState([]);
  const [corsoImageUrl, setCorsoImageUrl] = useState([]);
  const navigate = useNavigate();
  const UNSPLASH_ACCESS_KEY = "LaS9a7pDWZ6NLKZrAQa9NZz8C4yjlsDa1tfloZTMNoA";
  const userRole = localStorage.getItem("userRole");
  const [assocCandidates, setAssocCandidates] = useState([]);
  const [selectedTrainerIds, setSelectedTrainerIds] = useState([]);
  const [modalTrainer, setModalTrainer] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeModalTab, setActiveModalTab] = useState("anagrafica");
  const [trainers, setTrainers] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [isShowingAllTrainers, setIsShowingAllTrainers] = useState(false);
  const [associazione, setAssociazione] = useState([]);
  const [trainerData, setTrainerData] = useState(null);

  useEffect(() => {
    if (!userRole || (userRole !== "OPERATOR" && userRole !== "ADMIN")) {
      alert(
        "Accedi come amministratore o operatore per modificare le ricerche!"
      );
      localStorage.clear();
      navigate("/login");
      return;
    }

    fetchData();
    if (userRole === "ADMIN") {
      fetchAssocCandidates(0);
    }
    if (userRole === "OPERATOR") {
      fetchAssociazione();
      fetchAvailableTrainers();
    }
  }, [id, navigate, userRole]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const ricercaRes = await api.get(`/ricerche/${id}`);
      setRicerca(ricercaRes.data);
      setForm(ricercaRes.data);

      if (userRole === "ADMIN") {
        const sediRes = await api.get("/sedi");
        setSedi(sediRes.data);

        const mansioniRes = await api.get("/mansioni");
        setMansioni(mansioniRes.data);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchImageFromUnsplash = async (query) => {
    try {
      const res = await fetch(
        `https://api.unsplash.com/search/photos?query=${encodeURIComponent(
          query
        )}&client_id=${UNSPLASH_ACCESS_KEY}&per_page=1`
      );
      const data = await res.json();
      if (data.results && data.results.length > 0) {
        setCorsoImageUrl(data.results[0].urls.small);
      } else {
        setCorsoImageUrl("");
      }
    } catch (error) {
      console.error(error);
      setCorsoImageUrl("");
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  const fetchAssocCandidates = async (page = 0, size = 10) => {
    try {
      setLoading(true);

      const res = await api.get(
        `/associazioni/ricerca/${id}/candidates?page=${page}&size=${size}`
      );

      const { content, totalPages } = res.data;

      setAssocCandidates(content);
      setTotalPages(totalPages);
      setCurrentPage(page);
      setIsShowingAllTrainers(false);
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        transition: Bounce,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };
  const fetchAssociazione = async () => {
    try {
      setLoading(true);

      const res = await api.get(`/associazioni/ricerca/${id}`);
      setAssociazione(res.data || []);
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        transition: Bounce,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchAvailableTrainers = async () => {
    try {
      const response = await api.get(`/associazioni/trainers/available`);
      setTrainerData(response.data);
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        transition: Bounce,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    const titolo = form.titoloCorso || ricerca?.titoloCorso;
    if (titolo) {
      fetchImageFromUnsplash(titolo);
    }
  }, [form.titoloCorso, ricerca]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const err = {};
    if (!form.titoloModulo)
      err.titoloModulo = "Il campo Titolo Modulo non può essere vuoto!";
    if (!form.titoloCorso)
      err.titoloCorso = "Il campo Titolo Corso non può essere vuoto!";
    if (!form.ore) err.ore = "Il campo Ore non può essere vuoto!";
    else if (form.statoRicerca !== "APERTA" && form.statoRicerca !== "CHIUSA")
      err.statoRicerca = "Lo stato ricerca deve essere 'APERTA' o 'CHIUSA'!";
    if (!form.statoRicerca) err.statoRicerca = "Seleziona uno stato!";
    if (!form.idSede) err.idSede = "Seleziona una sede!";
    if (!form.idMansione) err.idMansione = "Seleziona una mansione!";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSave = async (e) => {
    if (!validate()) return;

    try {
      setLoading(true);
      const payload = {
        titoloModulo: form.titoloModulo,
        titoloCorso: form.titoloCorso,
        ore: parseInt(form.ore),
        statoRicerca: form.statoRicerca,
        idSede: parseInt(form.idSede),
        idMansione: parseInt(form.idMansione),
      };

      const res = await api.put(`/ricerche/${id}`, payload);

      if (res.status === 204) {
        toast.success("Ricerca aggiornata con successo!", {
          transition: Bounce,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        let { name, value } = e.target;
        if (name === "idSede" || name === "idMansione" || name === "ore") {
          value = value === "" ? "" : Number(value);
        }

        setForm((prev) => ({ ...prev, [name]: value }));
        setIsEditing(false);
        setErrors({});
        fetchData();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        transition: Bounce,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  const addAssociazioneOrBulk = async () => {
    if (selectedTrainerIds.length === 1) {
      await addAssociazione(selectedTrainerIds[0]);
    } else if (selectedTrainerIds.length > 1) {
      await addBulkAssociazione({
        trainerIds: selectedTrainerIds,
      });
    } else {
      toast.warning("Seleziona almeno un docente!", {
        transition: Bounce,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const addAssociazione = async (trainerId) => {
    try {
      const res = await api.post("/associazioni", {
        trainerId,
        ricercaId: ricerca.idRicerca,
      });

      if (res.status === 200 || res.status === 201) {
        toast.success("Associazione creata!");
        setSelectedTrainerIds([]);
        fetchAssocCandidates();
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        transition: Bounce,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const addBulkAssociazione = async (payload) => {
    try {
      const response = await api.post(`/associazioni/${id}/bulk`, payload);

      if (response.status === 200) {
        toast.success("Associazioni create con successo!", {
          transition: Bounce,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setSelectedTrainerIds([]);
        fetchAssocCandidates();
      }
    } catch (error) {
      console.error("Errore bulk:", error);

      toast.error(error?.response?.data?.message, {
        transition: Bounce,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleCheckboxChange = (trainerId) => {
    setSelectedTrainerIds((prevSelected) =>
      prevSelected.includes(trainerId)
        ? prevSelected.filter((id) => id !== trainerId)
        : [...prevSelected, trainerId]
    );
  };

  const handleRowClick = (trainer) => {
    setModalTrainer(trainer);
  };

  const closeModal = () => {
    setModalTrainer(null);
  };

  const fetchTrainers = async (page = 0, size = 10) => {
    try {
      setLoading(true);
      const response = await api.get(`/trainers?page=${page}&size=${size}`);
      const { content, page: pageInfo } = response.data;

      const formattedDocenti = content.map((trainer) => ({
        anagrafica: {
          id: trainer.id,
          nome: trainer.nome,
          cognome: trainer.cognome,
          codiceFiscale: trainer.codiceFiscale,
          email: trainer.email,
          sesso: trainer.sesso,
          cittàDiResidenza: trainer.cittàDiResidenza,
        },
        dataCreazione: trainer.dataCreazione,
      }));

      setAssocCandidates(formattedDocenti);
      setTotalPages(pageInfo.totalPages);
      setCurrentPage(page);
      setIsShowingAllTrainers(true);
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        transition: Bounce,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="overlay">
        <div className="spinner"></div>
      </div>
    );
  if (!ricerca)
    return (
      <div className="overlay">
        <div className="spinner"></div>
      </div>
    );

  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption?.value || "";
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  function formatDateOnly(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  const modalTabs = [
    { key: "anagrafica", label: "Anagrafica" },
    { key: "interviste", label: "Interviste" },
    { key: "esperienze", label: "Esperienze Lavorative" },
    { key: "candidature", label: "Candidature" },
    { key: "simulazioni", label: "Simulazioni" },
    { key: "moduli", label: "Moduli Protocollati" },
    { key: "accordo", label: "Accordo Quadro" },
    { key: "ricerca", label: "Ricerca Associata" },
  ];

  return (
    <div className="edit-ricerche-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="edit-ricerche-card">
        {/* Header */}
        <div className="edit-ricerche-header">
          <button
            onClick={() =>
              navigate(userRole === "ADMIN" ? "/ricerche" : "/ricerche/me")
            }
            className="edit-ricerche-back-btn"
          >
            <i className="fa-solid fa-arrow-left"></i>
            <span>Torna alle ricerche</span>
          </button>
          <h1 className="edit-ricerche-title">Modifica Ricerca</h1>
          <div className="edit-ricerche-actions">
            {!isEditing && (
              <button
                className="edit-ricerche-edit-btn"
                onClick={() => setIsEditing(true)}
              >
                <i className="fa-solid fa-edit"></i>
                <span>Modifica</span>
              </button>
            )}
          </div>
        </div>

        {/* Main Form Content */}
        <div className={`edit-ricerche-content ${isEditing ? "editing" : ""}`}>
          <div className="edit-ricerche-image">
            {corsoImageUrl && <img src={corsoImageUrl} alt="Immagine corso" />}
          </div>

          <form
            className="edit-ricerche-form"
            onSubmit={(e) => {
              e.preventDefault();
              handleSave(e);
            }}
          >
            <div className="edit-ricerche-fields">
              {userRole === "ADMIN" && (
                <div className="edit-ricerche-field">
                  <label className="edit-ricerche-label">Sede</label>
                  {isEditing ? (
                    <CustomSelect
                      options={sedi.map((s) => ({
                        value: s.idSede,
                        label: s.indirizzoSede,
                      }))}
                      value={
                        form.idSede
                          ? {
                              value: form.idSede,
                              label:
                                sedi.find((s) => s.idSede === form.idSede)
                                  ?.indirizzoSede || "",
                            }
                          : null
                      }
                      onChange={(option) =>
                        handleSelectChange("idSede", option)
                      }
                      placeholder="Seleziona una sede"
                    />
                  ) : (
                    <span className="edit-ricerche-value">
                      {sedi.find((s) => s.idSede === ricerca.idSede)
                        ?.indirizzoSede || "N/A"}
                    </span>
                  )}
                  {errors.idSede && (
                    <span className="edit-ricerche-error">{errors.idSede}</span>
                  )}
                </div>
              )}

              {userRole === "ADMIN" && (
                <div className="edit-ricerche-field">
                  <label className="edit-ricerche-label">Mansione</label>
                  {isEditing ? (
                    <CustomSelect
                      options={mansioni.map((m) => ({
                        value: m.idMansione,
                        label: m.nomeMansione,
                      }))}
                      value={
                        form.idMansione
                          ? {
                              value: form.idMansione,
                              label:
                                mansioni.find(
                                  (m) => m.idMansione === form.idMansione
                                )?.nomeMansione || "",
                            }
                          : null
                      }
                      onChange={(option) =>
                        handleSelectChange("idMansione", option)
                      }
                      placeholder="Seleziona una mansione"
                    />
                  ) : (
                    <span className="edit-ricerche-value">
                      {mansioni.find((m) => m.idMansione === ricerca.idMansione)
                        ?.nomeMansione || "N/A"}
                    </span>
                  )}
                  {errors.idMansione && (
                    <span className="edit-ricerche-error">
                      {errors.idMansione}
                    </span>
                  )}
                </div>
              )}

              <div className="edit-ricerche-field">
                <label className="edit-ricerche-label">Titolo Corso</label>
                {isEditing ? (
                  <input
                    type="text"
                    name="titoloCorso"
                    className="edit-ricerche-input"
                    value={form.titoloCorso || ""}
                    onChange={handleChange}
                  />
                ) : (
                  <span className="edit-ricerche-value">
                    {ricerca.titoloCorso}
                  </span>
                )}
                {errors.titoloCorso && (
                  <span className="edit-ricerche-error">
                    {errors.titoloCorso}
                  </span>
                )}
              </div>

              <div className="edit-ricerche-field">
                <label className="edit-ricerche-label">Titolo Modulo</label>
                {isEditing ? (
                  <input
                    type="text"
                    name="titoloModulo"
                    className="edit-ricerche-input"
                    value={form.titoloModulo || ""}
                    onChange={handleChange}
                  />
                ) : (
                  <span className="edit-ricerche-value">
                    {ricerca.titoloModulo}
                  </span>
                )}
                {errors.titoloModulo && (
                  <span className="edit-ricerche-error">
                    {errors.titoloModulo}
                  </span>
                )}
              </div>

              <div className="edit-ricerche-field">
                <label className="edit-ricerche-label">Ore</label>
                {isEditing ? (
                  <input
                    type="number"
                    name="ore"
                    className="edit-ricerche-input"
                    value={form.ore || ""}
                    onChange={handleChange}
                  />
                ) : (
                  <span className="edit-ricerche-value">{ricerca.ore}</span>
                )}
                {errors.ore && (
                  <span className="edit-ricerche-error">{errors.ore}</span>
                )}
              </div>

              <div className="edit-ricerche-field">
                <label className="edit-ricerche-label">Stato Ricerca</label>
                {isEditing ? (
                  <CustomSelect
                    options={[
                      { value: "APERTA", label: "APERTA" },
                      { value: "CHIUSA", label: "CHIUSA" },
                      { value: "IN_ATTESA", label: "IN ATTESA" },
                    ]}
                    value={
                      form.statoRicerca
                        ? [
                            { value: "APERTA", label: "APERTA" },
                            { value: "CHIUSA", label: "CHIUSA" },
                            { value: "IN_ATTESA", label: "IN ATTESA" },
                          ].find((opt) => opt.value === form.statoRicerca)
                        : null
                    }
                    onChange={(selected) =>
                      setForm((prev) => ({
                        ...prev,
                        statoRicerca: selected ? selected.value : "",
                      }))
                    }
                    placeholder="Seleziona lo stato della ricerca"
                  />
                ) : (
                  <span className="edit-ricerche-value">
                    {ricerca.statoRicerca}
                  </span>
                )}
              </div>

              <div className="edit-ricerche-field">
                <label className="edit-ricerche-label">Data Creazione</label>
                <span className="edit-ricerche-value">
                  {ricerca.dataCreazione
                    ? (() => {
                        const d = new Date(ricerca.dataCreazione);
                        const day = String(d.getDate()).padStart(2, "0");
                        const month = String(d.getMonth() + 1).padStart(2, "0");
                        const year = d.getFullYear();
                        return `${day}.${month}.${year}`;
                      })()
                    : ""}
                </span>
              </div>

              <div className="edit-ricerche-field">
                <label className="edit-ricerche-label">Autore</label>
                <span className="edit-ricerche-value">{ricerca.autore}</span>
              </div>
            </div>

            {isEditing && (
              <div className="edit-ricerche-actions-panel">
                <button
                  className="edit-ricerche-cancel-btn"
                  type="button"
                  onClick={() => {
                    setForm(ricerca);
                    setErrors({});
                    setIsEditing(false);
                  }}
                >
                  Annulla
                </button>
                <button className="edit-ricerche-save-btn" type="submit">
                  Salva modifiche
                </button>
              </div>
            )}
          </form>
        </div>
      </div>

      {userRole === "ADMIN" && assocCandidates?.length > 0 ? (
        <div className="trainer-table-section">
          <div className="trainer-table-title">
            {isShowingAllTrainers
              ? "Tutti docenti"
              : "Possibili associazioni alla ricerca"}
          </div>
          {isShowingAllTrainers ? (
            <button
              className="fetch-trainers"
              onClick={() => fetchAssocCandidates(0)}
            >
              Mostra solo i docenti compatibili
            </button>
          ) : (
            <button className="fetch-trainers" onClick={() => fetchTrainers(0)}>
              Vedi tutti i docenti
            </button>
          )}
          <div className="trainer-table-wrapper">
            <table className="trainer-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Codice Fiscale</th>
                  <th>Nome e cognome</th>
                  <th>Email</th>
                  <th>Sesso</th>
                  <th>Città Di Residenza</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {assocCandidates.map((trainer) => {
                  const trainerId = trainer.anagrafica.id;
                  const isSelected = selectedTrainerIds.includes(trainerId);

                  return (
                    <tr
                      key={trainerId}
                      onClick={(e) => {
                        if (e.target.type !== "checkbox") {
                          handleRowClick(trainer);
                        }
                      }}
                      className={isSelected ? "selected" : ""}
                    >
                      <td onClick={(e) => e.stopPropagation()}>
                        <label className="custom-checkbox">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => handleCheckboxChange(trainerId)}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </td>

                      <td data-label="Codice Fiscale">
                        {trainer.anagrafica.codiceFiscale}
                      </td>
                      <td data-label="Nome e cognome">
                        {trainer.anagrafica.nome} {trainer.anagrafica.cognome}
                      </td>
                      <td data-label="Email">{trainer.anagrafica.email}</td>
                      <td data-label="Sesso">{trainer.anagrafica.sesso}</td>
                      <td data-label="Città Di Residenza">
                        {trainer.anagrafica.cittàDiResidenza}
                      </td>
                      <td data-label=""></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="pagination-controls">
              <button
                onClick={() =>
                  isShowingAllTrainers
                    ? fetchTrainers(currentPage - 1)
                    : fetchAssocCandidates(currentPage - 1)
                }
                disabled={currentPage === 0}
                className="pagination-btn"
              >
                <i className="fa-solid fa-angle-left"></i>
              </button>

              <span className="pagina">
                Pagina {currentPage + 1} di {totalPages || 1}
              </span>

              <button
                onClick={() => {
                  isShowingAllTrainers
                    ? fetchTrainers(currentPage + 1)
                    : fetchAssocCandidates(currentPage + 1);
                }}
                disabled={currentPage + 1 >= totalPages}
                className="pagination-btn"
              >
                <i className="fa-solid fa-angle-right"></i>
              </button>
            </div>
          </div>
          {selectedTrainerIds.length > 0 && (
            <button onClick={addAssociazioneOrBulk} className="add-assoc">
              {selectedTrainerIds.length === 1
                ? "Crea associazione"
                : "Aggiungi associazioni selezionate"}
            </button>
          )}
        </div>
      ) : (
        ""
      )}

      {userRole === "OPERATOR" && associazione.length > 0 && (
        <div className="trainer-table-wrapper">
          <div className="trainer-table-title">
            Docenti associati alla ricerca
          </div>
          <table className="trainer-table">
            <thead>
              <tr>
                <th>Codice Fiscale</th>
                <th>Nome e cognome</th>
                <th>Email</th>
                <th>Stato Occupazionale</th>
                <th>Livello Inglese</th>
                <th>Livello Informatica</th>
              </tr>
            </thead>
            <tbody>
              {associazione.map((item) => {
                const trainer = item.trainer;
                return (
                  <tr
                    key={item.idAssociazione}
                    onClick={() => {
                      const fullTrainerData = trainerData?.find(
                        (t) => t.anagrafica.id === trainer.id
                      );
                      navigate(`/docente/disponibile/${trainer.id}`, {
                        state: {
                          trainer: fullTrainerData,
                        },
                      });
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <td data-label="Codice Fiscale">{trainer.codiceFiscale}</td>
                    <td data-label="Nome e cognome">
                      {trainer.nome} {trainer.cognome}
                    </td>
                    <td data-label="Email">{trainer.email}</td>
                    <td data-label="Stato Occupazionale">
                      {trainer.statoOccupazionale}
                    </td>
                    <td data-label="Livello Inglese">
                      {trainer.livelloInglese}
                    </td>
                    <td data-label="Livello Informatica">
                      {trainer.livelloInformatica}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {modalTrainer && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-title">Dettagli del docente</div>
            <button className="close-modal" onClick={closeModal}>
              <i className="fa-solid fa-xmark"></i>
            </button>

            {/* Modal Tabs */}
            <div className="modal-tabs">
              {modalTabs.map((tab) => (
                <button
                  key={tab.key}
                  className={`modal-tab-btn${
                    activeModalTab === tab.key ? " active" : ""
                  }`}
                  onClick={() => setActiveModalTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className="modal-tab-content">
              {/* Anagrafica Tab */}
              {activeModalTab === "anagrafica" && (
                <div className="trainer-data-section">
                  <div className="trainer-data-secton-title">
                    Docente anagrafica
                  </div>
                  <div className="trainer-data-section-content">
                    <div className="data-group">
                      <div className="data-label">Nome e cognome: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.nome}
                          {modalTrainer.anagrafica.cognome}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Codice Fiscale: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.codiceFiscale}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Email: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.email}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Cellulare: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.cellulare}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Città Di Residenza: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.cittàDiResidenza}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Via: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.via}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Provincia: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.provincia}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Sesso: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.sesso}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Data Di Nascita: </div>
                      <div className="data-value">
                        <span className="value">
                          {formatDateOnly(
                            modalTrainer.anagrafica.dataDiNascita
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Stato Occupazionale: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.statoOccupazionale}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Livello Inglese: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.livelloInglese}
                        </span>
                      </div>
                    </div>
                    <div className="data-group">
                      <div className="data-label">Livello Informatica: </div>
                      <div className="data-value">
                        <span className="value">
                          {modalTrainer.anagrafica.livelloInformatica}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Interviste Tab */}
              {activeModalTab === "interviste" &&
                modalTrainer.interviste.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">Interviste</div>
                    {modalTrainer.interviste.length > 0 &&
                      modalTrainer.interviste?.map((intervista, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Data Intervista: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDateOnly(intervista.dataIntervista)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Parlantina: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.parlantina ? "Si" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Timidezza: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.timidezza ? "Si" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Dinamicità: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.dinamicità ? "Si" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Empatia: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.empatia}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Inglese: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.inglese}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Adeguato Insegnamento:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.adeguatoInsegnamento}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Automunito: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.automunito ? "Si" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Piva: </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.piva ? "Si" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Luogo Lavorativo Desiderato:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.luogoLavorativoDesiderato}
                              </span>
                            </div>
                          </div>
                          {intervista.annotazioneInterna && (
                            <div className="data-group">
                              <div className="data-label">
                                Annotazione Interna:{" "}
                              </div>
                              <div className="data-value">
                                <span className="value">
                                  {intervista.annotazioneInterna}
                                </span>
                              </div>
                            </div>
                          )}
                          <div className="data-group">
                            <div className="data-label">
                              Punteggio Intervista:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {intervista.punteggioIntervista}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Autore: </div>
                            <div className="data-value">
                              <span className="value">{intervista.autore}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Esperienze Lavorative Tab */}
              {activeModalTab === "esperienze" &&
                modalTrainer.esperienzeLavorative.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">
                      Esperienze Lavorative
                    </div>
                    {modalTrainer.esperienzeLavorative.length > 0 &&
                      modalTrainer.esperienzeLavorative?.map((esp, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Ruolo: </div>
                            <div className="data-value">
                              <span className="value">{esp.ruolo}</span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Nome Mansione: </div>
                            <div className="data-value">
                              <span className="value">
                                {esp.mansione.nomeMansione}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Dal: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDateOnly(esp.dal)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Al: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDateOnly(esp.al)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Nome Azienda: </div>
                            <div className="data-value">
                              <span className="value">{esp.nomeAzienda}</span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Descrizione Ruolo:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {esp.descrizioneRuolo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Conteggio Esperienza:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {esp.conteggioEsperienza}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Data Creazione: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDateOnly(esp.dataCreazione)}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Candidature Tab */}
              {activeModalTab === "candidature" &&
                modalTrainer.candidature.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">Candidature</div>
                    {modalTrainer.candidature.length > 0 &&
                      modalTrainer.candidature?.map((candidatura, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Data Candidatura: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDateOnly(candidatura.dataCandidatura)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Esito: </div>
                            <div className="data-value">
                              <span className="value">{candidatura.esito}</span>
                            </div>
                          </div>
                          {candidatura.descrizioneEsito && (
                            <div className="data-group">
                              <div className="data-label">
                                Descrizione Esito:{" "}
                              </div>
                              <div className="data-value">
                                <span className="value">
                                  {candidatura.descrizioneEsito}
                                </span>
                              </div>
                            </div>
                          )}
                          {modalTrainer.candidature.dataEsito && (
                            <div className="data-group">
                              <div className="data-label">Data Esito: </div>
                              <div className="data-value">
                                <span className="value">
                                  {formatDateOnly(candidatura.dataEsito)}
                                </span>
                              </div>
                            </div>
                          )}
                          <div className="data-group">
                            <div className="data-label">Titolo Modulo: </div>
                            <div className="data-value">
                              <span className="value">
                                {candidatura.titoloModulo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Sede Indirizzo: </div>
                            <div className="data-value">
                              <span className="value">
                                {candidatura.sedeIndirizzo}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Simulazioni Tab */}
              {activeModalTab === "simulazioni" &&
                modalTrainer.simulazioni.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">Simulazioni</div>
                    {modalTrainer.simulazioni.length > 0 &&
                      modalTrainer.simulazioni?.map((simulazione, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Data Inserimento: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDateOnly(simulazione.dataInserimento)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Link: </div>
                            <div className="data-value">
                              <span className="value">
                                <a
                                  href={simulazione.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {simulazione.link}
                                </a>
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Autore: </div>
                            <div className="data-value">
                              <span className="value">
                                {simulazione.autore}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Data Inserimento: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDateOnly(simulazione.dataInserimento)}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Moduli Protocollati Tab */}
              {activeModalTab === "moduli" &&
                modalTrainer.moduliProtocollati.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">
                      Moduli Protocollati
                    </div>
                    {modalTrainer.moduliProtocollati.length > 0 &&
                      modalTrainer.moduliProtocollati?.map((moduli, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Data Creazione: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDateOnly(moduli.dataCreazione)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Titolo Modulo: </div>
                            <div className="data-value">
                              <span className="value">
                                {moduli.titoloModulo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Ore Modulo: </div>
                            <div className="data-value">
                              <span className="value">{moduli.oreModulo}</span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Modalità Erogazione:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {moduli.modalitàErogazione}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Materiale Attrezzature:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {moduli.materialeAttrezzature}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Previste Dispense:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {moduli.previsteDispense}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Prove Finali: </div>
                            <div className="data-value">
                              <span className="value">
                                {moduli.proveFinali}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Accordo Quadro Tab */}
              {activeModalTab === "accordo" &&
                modalTrainer.accordoQuadro.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">
                      Accordo Quadro
                    </div>
                    {modalTrainer.accordoQuadro.length > 0 &&
                      modalTrainer.accordoQuadro?.map((accordo, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Data Accordo: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDateOnly(accordo.dataAccordo)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Tipologia Accordo:{" "}
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {accordo.tipologiaAccordo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Quota Da Sistema: </div>
                            <div className="data-value">
                              <span className="value">
                                {accordo.quotaDaSistema}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Livello Accordo: </div>
                            <div className="data-value">
                              <span className="value">
                                {accordo.livelloAccordo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Quota Oraria: </div>
                            <div className="data-value">
                              <span className="value">
                                {accordo.quotaOraria}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Importo Definito: </div>
                            <div className="data-value">
                              <span className="value">
                                {accordo.importoDefinito}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">
                              Data Prossimo Aggiornamento:
                            </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDateOnly(
                                  accordo.dataProssimoAggiornamento
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Autore:</div>
                            <div className="data-value">
                              <span className="value">{accordo.autore}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Ricerca Associata Tab */}
              {activeModalTab === "ricerca" &&
                modalTrainer?.ricercaAssociata?.length > 0 && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">
                      Ricerca Associata
                    </div>
                    {modalTrainer?.ricercaAssociata?.length > 0 &&
                      modalTrainer.ricercaAssociata.map((ricerca, index) => (
                        <div
                          className="trainer-data-section-content"
                          key={index}
                        >
                          <div className="data-group">
                            <div className="data-label">Titolo Corso: </div>
                            <div className="data-value">
                              <span className="value">
                                {ricerca.titoloCorso}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Titolo Modulo: </div>
                            <div className="data-value">
                              <span className="value">
                                {ricerca.titoloModulo}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Ore: </div>
                            <div className="data-value">
                              <span className="value">{ricerca.ore}</span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Stato Ricerca: </div>
                            <div className="data-value">
                              <span className="value">
                                {ricerca.statoRicerca}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Data Creazione: </div>
                            <div className="data-value">
                              <span className="value">
                                {formatDateOnly(ricerca.dataCreazione)}
                              </span>
                            </div>
                          </div>
                          <div className="data-group">
                            <div className="data-label">Autore: </div>
                            <div className="data-value">
                              <span className="value">{ricerca.autore}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

              {/* Empty State */}
              {activeModalTab !== "anagrafica" &&
                ((activeModalTab === "interviste" &&
                  modalTrainer.interviste.length === 0) ||
                  (activeModalTab === "esperienze" &&
                    modalTrainer.esperienzeLavorative.length === 0) ||
                  (activeModalTab === "candidature" &&
                    modalTrainer.candidature.length === 0) ||
                  (activeModalTab === "simulazioni" &&
                    modalTrainer.simulazioni.length === 0) ||
                  (activeModalTab === "moduli" &&
                    modalTrainer.moduliProtocollati.length === 0) ||
                  (activeModalTab === "accordo" &&
                    modalTrainer.accordoQuadro.length === 0) ||
                  (activeModalTab === "ricerca" &&
                    (!modalTrainer?.ricercaAssociata ||
                      modalTrainer.ricercaAssociata.length === 0))) && (
                  <div className="trainer-data-section">
                    <div className="trainer-data-secton-title">
                      {
                        modalTabs.find((tab) => tab.key === activeModalTab)
                          ?.label
                      }
                    </div>
                    <div className="trainer-data-section-content">
                      <div className="data-group">
                        <div className="data-value">
                          <span
                            className="value"
                            style={{
                              textAlign: "center",
                              width: "100%",
                              color: "#6c757d",
                              fontStyle: "italic",
                            }}
                          >
                            Nessun dato disponibile per questa sezione
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditRicerche;
